export default {
    back4app_url: "https://parseapi.back4app.com/",
    back4app_wss_url: "wss://bellwether.back4app.io",
    back4app_secret: "ZI0Ur1QMnOq3JZC3L3AOF7s8CMIhckYa6qduvrCS",
    back4app_key_id: "P77qTT6iRAko4LHeZxzAhs1pDx0bf5vaoPMdlwMM",
    bw_api_url: "https://admin.staging.bellwether.link/api",
    tower_api_url: "https://tower-api.staging.bellwether.link"
}
